import {
	Id,
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
} from "@dgs/core";
import axios from "axios";
import { IEventClippingsResource, IEventContactIndexResource, IEventUpdateCostRequest } from "../../types";

export type IEventContactEndpoints = ReturnType<typeof withEventContactEndpoints>;

export const withEventContactEndpoints = (baseKey: string[]) => {
	const contactsKey = (eventId: Id) => [...baseKey, `${eventId}`, "contacts"];
	const exportContactsKey = (eventId: Id) => [...baseKey, `${eventId}`, "contacts", "export"];
	const updateContactCostKey = (eventId: Id, contactId: Id) => [
		...baseKey,
		`${eventId}`,
		"contacts",
		`${contactId}`,
		"cost",
	];
	const numberOfClippingsKey = (eventId: Id) => [...baseKey, `${eventId}`, "clippings"];

	return {
		contacts: (
			eventId: Id,
			contactFilterId: number | null,
			config: PaginatedListFetcherConfig<IEventContactIndexResource>,
		) => {
			const axiosConfig = mapPaginatedFetcherConfigToAxiosConfig(config);

			return axios.get<LaravelResponse<IEventContactIndexResource[]>>(keyToUrl(contactsKey(eventId)), {
				params: {
					...axiosConfig.params,
					sort: config.sortParams
						? {
								[typeof config.sortParams.column === "string" ? "customContactAttributeName" : "contactAttributeId"]:
									config.sortParams.column,
								direction: config.sortParams.direction,
							}
						: null,
					contactFilterId,
				},
			});
		},
		contactsKey,
		updateContactCost: (eventId: Id, contactId: Id, costRequest: IEventUpdateCostRequest) =>
			axios.put(keyToUrl(updateContactCostKey(eventId, contactId)), costRequest),
		numberOfClippings: (eventId: Id) =>
			axios.get<LaravelResponse<IEventClippingsResource>>(keyToUrl(numberOfClippingsKey(eventId))),
		numberOfClippingsKey,
		exportContacts: (eventId: Id, contactViewId?: Id, contactFilterId?: Id | null) =>
			axios.post(keyToUrl(exportContactsKey(eventId)), {
				contactFilterId,
				contactViewId,
			}),
	};
};
